<div class="row">
  <div class="col-md-12 col-sm-12 col-xs-12 nopad">
      <h2 class="SectionHeading">Announcements</h2>
  </div>
</div>

<div id="listView" class="container bannerSection boxShadow tab-pane active" style="padding:30px;">
  <div class="col-md-12 col-sm-12 col-xs-12 nopad">
    <!-- <table>
      <thead>
        <tr>
          <th scope="col">S.No.</th>
          <th scope="col">Subject</th>
          <th scope="col">Date</th>
          <th scope="col">Details</th>
          <th scope="col">File</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let announcement of announcements;let i=index;">
          <td scope="row" data-label="sno" class="annouSerial">{{i+1}}</td>
          <td data-label="subject" class="text-left annouTitle">{{announcement?.title}}</td>
          <td data-label="date" class="annouDate">{{announcement?.announcement_date | date:'fullDate'}}</td>
          <td data-label="attachment" class="text-left annouBody">{{announcement?.body}}</td>
          <td data-label="file" class="text-left annouBody">
            <div *ngIf="announcement.file">
              <a target="_blank" href="{{baseBackUrl}}/downloadAnnouncementHomepage?id={{announcement.id}}">
                  <mat-icon matTooltip="{{announcement.file}}">remove_red_eye</mat-icon>
              </a>
            </div>
            <div *ngIf="!announcement.file">
                <p>--</p>
            </div>
          </td>
        </tr>
      </tbody>

    </table> -->

  <div class="clearfix"></div>


  <mat-table #matTable class="dataTable" [dataSource]="dataSource" matSort #sort="matSort">
    <ng-container matColumnDef="sno">
        <mat-header-cell *matHeaderCellDef> S No. </mat-header-cell>
        <mat-cell *matCellDef="let i=index;"> {{i+1}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="subject">
        <mat-header-cell *matHeaderCellDef> Subject </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element?.title}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element?.announcement_date | date:'dd/MM/y'}} </mat-cell>
    </ng-container>

    <!-- <ng-container matColumnDef="details">
        <mat-header-cell *matHeaderCellDef> Details </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element?.body | slice:0:30}} ... </mat-cell>
    </ng-container> -->

    <ng-container matColumnDef="file">
        <mat-header-cell *matHeaderCellDef> File </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div *ngIf="element.file">
          <a (click)='openAnnouncementLink(element?.id)'>
            <mat-icon matTooltip="{{element.file}}">remove_red_eye</mat-icon>
          </a>
        </div>
          <div *ngIf="!element.file">
            <p>--</p>
        </div>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="url">
      <mat-header-cell *matHeaderCellDef> URL </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div *ngIf="element.url">
        <a target="_blank" (click)="routeByUrl(element.url)">
          <mat-icon matTooltip="{{element.url}}" class="url">remove_red_eye</mat-icon>
        </a>
      </div>
        <div *ngIf="!element.url">
          <p>--</p>
      </div>
      </mat-cell>
  </ng-container>


    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    <!-- <mat-row *matNoDataRow>
        <mat-cell colspan="4">No data matching the filter</mat-cell>
    </mat-row> -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No data matching the filter</td>
  </tr>

  </mat-table>
  <div *ngIf="!announcements">
      <p class="text-center" style="padding-top: 35px; font-size: 18px; color: red;">No Announcements & Notices</p>
  </div>
 </div>
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons>
</mat-paginator>
</div>
